import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import { useTranslation } from "react-i18next";
import {
  deleteAccountWithApple,
  loginToDelete,
} from "./delete_account_controller";
import { GoogleLogin } from "@react-oauth/google";
import AppleLoginButton from "./component/apple_login_button";
import GoogleLoginButton from "./component/google_login_button";

function DeleteAccount() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await loginToDelete(email, password, navigator.language);
      alert(t("delete_submited"));
    } catch (error) {
      alert(t("delete_submited"));
    }
  };

  const handleAppleLoginResponse = ({ idToken, email, lang }) => {
    deleteAccountWithApple(idToken, email, lang);
  };

  const handleGoogleLoginResponse = ({ idToken, email, lang }) => {
    deleteAccountWithApple(idToken, email, lang);
  };

  return (
    <div className="container">
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flex: 1,
          padding: "20px",
        }}
      >
        <div className="column">
          <p className="main-font-color">{t("delete_description")}</p>
          <form id="loginForm" onSubmit={handleSubmit}>
            <input
              type="email"
              id="email"
              placeholder={t("account_placeholder")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <br />
            <input
              type="password"
              id="password"
              placeholder={t("password_placeholder")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <br />
            <button className="primary_button medium_gap_top" type="submit">
              {t("login")}
            </button>
            <div className="medium_gap_top">
              <AppleLoginButton callback={handleAppleLoginResponse} />
            </div>
            <div className="medium_gap_top">
              <GoogleLoginButton callback={handleGoogleLoginResponse} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
